document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.password-toggle-btn').forEach((btn) => {
    btn.addEventListener('click', () => {
      const wrapper = btn.closest('.password-field-wrapper');
      if (!wrapper) return;

      const input = wrapper.querySelector('input[type="password"], input[type="text"]');
      const eyeOpen = btn.querySelector('.icon-eye-open');
      const eyeClose = btn.querySelector('.icon-eye-close');

      if (!input) return;

      if (input.type === 'password') {
        input.type = 'text';
        if (eyeOpen) eyeOpen.style.display = 'none';
        if (eyeClose) eyeClose.style.display = 'block';
      } else {
        input.type = 'password';
        if (eyeOpen) eyeOpen.style.display = 'block';
        if (eyeClose) eyeClose.style.display = 'none';
      }
    });
  });
});
